import { useMutation } from "@tanstack/react-query";
import { updateGender } from "../api/update-gender";

export const useUpdateGender = () => {
  return useMutation({
    mutationFn: updateGender,
  });
};
